<template>
    <v-navigation-drawer :value="value" right fixed temporary :width="width" class="ui-sheet" @input="$emit('input', $event)">
        <div v-if="value || keepContent" class="ui-sheet__inner">
            <header class="ui-sheet__header">
                <div><slot name="header"></slot></div>
                <v-btn icon aria-label="Fechar" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
            </header>
            <div class="ui-sheet__body"><slot></slot></div>
            <footer v-if="$slots.footer" class="ui-sheet__footer"><slot name="footer"></slot></footer>
        </div>
    </v-navigation-drawer>
</template>

<script>
// Painel lateral de detalhe com cabecalho, corpo rolavel e rodape fixo.
export default {
    name: "UiSheet",
    props: {
        value: { type: Boolean, default: false },
        width: { type: [Number, String], default: 640 },
        keepContent: { type: Boolean, default: true },
    },
};
</script>
